// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs__1EVo7"};